import {FormProvider, useForm} from 'react-hook-form';

import FormCheckbox from 'components/form/Checkbox';
import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


export default function SettingsForm({data, onSave}) {
  const appContext = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      accountNonExpired: data?.accountNonExpired,
      accountNonLocked: data?.accountNonLocked,
      enabled: data?.enabled,
      credentialsNonExpired: data?.credentialsNonExpired,
    },
  });


  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    try {
      await appContext.api.patch('api/v1/users/toggleaccountexpired', {
        json: values,
        parseJson: true,
      });
      await appContext.api.patch('api/v1/users/toggleaccountlocked', {
        json: values,
        parseJson: true,
      });
      await appContext.api.patch('api/v1/users/toggleaccountenabled', {
        json: values,
        parseJson: true,
      });
      await appContext.api.patch('api/v1/users/togglecredentialsexpired', {
        json: values,
        parseJson: true,
      });
      onSave('Account updated successfully.');
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row g-3">
          <div className="col-12">
            <FormCheckbox
              label="Account Expired"
              name="accountNonExpired"
              required={true}
            />
          </div>
          <div className="col-12">
            <FormCheckbox
              label="Account Locked"
              name="accountNonLocked"
              required={true}
            />
          </div>
          <div className="col-12">
            <FormCheckbox
              label="Account Enabled"
              name="enabled"
              required={true}
            />
          </div>
          <div className="col-12">
            <FormCheckbox
              label="Credential Expired"
              name="credentialsNonExpired"
              required={true}
            />
          </div>
        </div>
        <div className="text-end col mt-3">
          <FormError />
          <FormSubmit
            key="save"
            className="btn btn-lg btn-outline-light bg-black text-white"
          >
            Save
          </FormSubmit>
        </div>
      </form>
    </FormProvider>
  );
}
